/**
 * Return a value from the map if it exists.
 * If the value does not exists create a value using the factory method, add it to the map and return it.
 *
 * @param map Map to operate on.
 * @param key Key for lookup.
 * @param itemFactory Factory method that instantiates the value if it does not exist.
 */
export var getOrSetDefaultValue = function (map, key, itemFactory) {
    var item = map.get(key);
    if (!item) {
        item = itemFactory();
        map.set(key, item);
    }
    return item;
};
export var getWorkflowDefinitionBase = function (workflow) {
    return {
        id: workflow.id,
        kind: workflow.kind,
        visibility: workflow.visibility,
        collectionScopeType: workflow.collectionScopeType,
        inputTypes: workflow.inputTypes,
        outputTypes: workflow.outputTypes,
        correlatedSignals: workflow.correlatedSignals
    };
};
export var isHybridWorkflow = function (workflow) {
    return Array.isArray(workflow.correlatedSignals) && workflow.correlatedSignals.length > 0;
};
//# sourceMappingURL=utils.js.map